// import storeConfigQuery from '~layers/app/graphql/storeConfig.gql'
import type { MagentoCountry } from '~layers/app/types/magento.d.ts'

export function useStore() {
  const storeData = useState('storeData', () => null)

  async function fetchStoreData() {
    const result = await useGraphqlQuery('storeConfig', null, useGraphqlDefaultClient())

    if (!result.data) {
      return
    }

    storeData.value = result.data
  }

  const storeConfig = computed(() => storeData.value?.storeConfig)
  const countries = computed(() => storeData.value?.countries || [])

  const getCountry = (countryCode: string): MagentoCountry | null => countries.value.find(item => item.code === countryCode) || null
  const regions = (countryCode: string) => countries.value?.find(item => item.code === countryCode)?.regions || []
  const regionId = (countryCode: string, regionCode: string) => regions(countryCode).find(item => item.code === regionCode)?.id || null

  return {
    regionId,
    regions,
    storeConfig,
    countries,
    getCountry,
    fetchStoreData,
  }
}
